import React from "react";
import styled from "styled-components";
import { breakpoints } from "../styles/theme";

const MobileHeader: React.FC = () => {
  return (
    <HeaderContainer>
      <Logo src="/logo.svg" alt="Atten logo" />
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  display: none;

  @media (max-width: ${breakpoints.mobile}) {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: #fff;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #eee;
    z-index: 15;
  }
`;

const Logo = styled.img`
  height: 70px;
`;

export default MobileHeader;
